/* global jQuery COMPONENTS */

COMPONENTS.ComponentAmenities = (function ($) {
  function ComponentAmenities () {
    this.$component = $('[data-ecs-component="component-amenities"]')

    this.$sliders = $('[data-ecs-components-control="amenity-slider"]')
    this.$slidersCaptions = $('[data-ecs-components-control="amenity-slider-caption"]')
    this.$buttonTabs = this.$component.find('[data-ecs-components-control="category-tabs"]')
  }

  ComponentAmenities.prototype.refreshSliders = function (needle) {
    const $activeTab = $(`[data-ecs-amenities-slider-wrap][data-tab="${needle}"]`)
    const $slider = $activeTab.first().find('[data-ecs-components-control="amenity-slider"]')
    $slider.slick('refresh')
  }

  ComponentAmenities.prototype.init = function () {
    const component = this
    const utility = new COMPONENTS.Utility()

    component.$sliders.each(function () {
      const $slider = $(this)
      const slideCount = $slider.data('ecs-components-slide-count')

      let slideLink = null
      if ($("[data-ecs-components-control='amenity-slider-caption']").length && $slider.attr('data-ecs-components-amenity-category')) {
        slideLink = '.ecs_amenity_slider_caption_' + $slider.data('ecs-components-amenity-category')
      }

      // add titles from images to the slider dots
      var sliderDotTitles = false
      const sliderDotTitleAttr = $slider.attr('data-ecs-components-slider-dottitles')
      if (typeof sliderDotTitleAttr !== 'undefined' && sliderDotTitleAttr !== false) {
        sliderDotTitles = true
      }

      const sliderVars = utility.getSliderVars(1, slideLink, false, false, true, sliderDotTitles)
      if (parseInt(slideCount) > 1) {
        $slider.slick(sliderVars)
        utility.bindSliderAriaSelected($slider)
      }
    })

    component.$slidersCaptions.each(function () {
      const $slider = $(this)
      const slideCount = $slider.data('ecs-components-slide-count')
      let slideLink = null
      if ($slider.attr('data-ecs-components-amenity-category')) {
        slideLink = '.ecs_amenity_slider_' + $slider.data('ecs-components-amenity-category')
      }

      const sliderVars = utility.getSliderVars(1, slideLink, false, false, false)
      if (parseInt(slideCount) > 1) {
        $slider.slick(sliderVars)
        utility.bindSliderAriaSelected($slider)
      }
    })

    if (component.$buttonTabs.length) {
      component.$buttonTabs.tab();
    }

    if (component.$buttonTabs.length > 1) {
      $('.menu .item').tab({
        onVisible: function () {
          component.refreshSliders($(this).data('tab'))
          utility.initSliderCounters()
        }
      })
    }
  }

  return ComponentAmenities
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentAmenities = new COMPONENTS.ComponentAmenities()
  COMPONENTS.componentAmenities.init()
})
